import * as d3 from 'd3';

/**
 * Fetches the latest data from a CSV file.
 *
 * @returns {Array} - The data array fetched from the latest CSV file.
 */
export async function fetch_data_by_date(date) {
    const folder_path = './dataset/processed_data/'
    const current_date = date.replaceAll('-', '');
    const data_path = folder_path + current_date + '/' + current_date + '.csv';
    
    const daily_fetch_data = await d3.csv(data_path);
    return daily_fetch_data;
}

/**
 * Gets the current date in the specified format.
 *
 * @param {string} output_format - The desired output format ('yyyy-mm' or 'yyyymmdd').
 * @returns {string} - The current date in the specified format.
 */
export function get_current_date(output_format) {
    const now = new Date();
    const year = now.getFullYear();
    const month = String(now.getMonth() + 1).padStart(2, '0');
    const day = String(now.getDate()).padStart(2, '0');
    
    if(output_format == 'yyyy-mm') {
        return `${year}-${month}`;
    } else if (output_format == 'yyyymmdd') {
        return `${year}${month}${day}`;
    }
}

/**
 * Gets the last month in 'yyyy-mm' format from a given date.
 *
 * @param {string} input_date - The input date in 'yyyy-mm' format.
 * @returns {string} - The last month in 'yyyy-mm' format.
 */
export function get_last_month(input_date) {
    const [year, month] = input_date.split('-').map(Number);
  
    const lastMonth = month === 1 ? 12 : month - 1;
    const lastYear = month === 1 ? year - 1 : year;
    const formattedMonth = String(lastMonth).padStart(2, '0');
  
    return `${lastYear}-${formattedMonth}`;
}